module.exports = __webpack_public_path__ + "img/Group_27994@2x.375c5271.png";